/* unplugin-vue-components disabled */import { render } from "./SwipeComponent.vue?vue&type=template&id=0ed1d2d3&scoped=true"
import script from "./SwipeComponent.vue?vue&type=script&lang=js"
export * from "./SwipeComponent.vue?vue&type=script&lang=js"

import "./SwipeComponent.vue?vue&type=style&index=0&id=0ed1d2d3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed1d2d3"]])

export default __exports__